import React, { Component } from 'react'
import { connect } from 'react-redux';
import styled from 'styled-components';
import { changeUpVariables, changeDownVariables } from '../actions';
import { constrain } from '../utils';
/*! Scrubbing 02-01-2014
 * Fabrice Weinberg
 */
!function (a, b) { var c = function (a, b) { return a ? "string" == typeof a ? b[a] : a : void 0 }, d = function (a, b, d, e, f) { a[f] = b ? c(b[f], e) || d[f] : d[f] }, e = function (a, b, c, d, e) { Array.isArray(a) ? a.forEach(function (a) { a[b](c, d, e) }) : a[b](c, d, e) }, f = { init: function () { }, start: function (a) { return parseInt(a.node.textContent, 10) }, change: function (a, b) { a.node.textContent = b }, end: function () { } }, g = function (a, b, c, d) { this.name = a, this.prop = b, this.factor = c || 1, this.divider = d || 1 }; g.prototype = { coordinate: function (a) { return a[this.prop] }, value: function (a, b) { return this.factor * Math.floor((b - a) / this.divider) } }; var h = function (a, b, c) { return function (d) { return new g(a, b, c, d) } }, i = h("Horizontal", "clientX"), j = h("Vertical", "clientY", -1), k = function () { var b, c, d = function () { this.removeEventListener("mousemove", b, !1), c && c.options.adapter.end(c) }, e = function (e) { if (e.target.scrubbingElement) { e.preventDefault(), c = e.target.scrubbingElement; var f = c.options.adapter.start(c), g = function (a) { return c.options.resolver.coordinate(a) }, h = g(e); return b = function (a) { if (1 === a.which) { var b = c.options.resolver.value(h, g(a)); c.options.adapter.change(c, f + b, b) } else d() }, a.addEventListener("mousemove", b, !1), a.addEventListener("mouseup", d, !1), !0 } }, f = function () { a.addEventListener("mousedown", e, !1), f = function () { } }; return { init: function () { f() }, remove: function () { } } }(), l = function (a) { var b, c, d = function () { a.removeEventListener("touchmove", c, !1), b && b.options.adapter.end(b) }, e = function (d) { if (1 === d.targetTouches.length) { var e = d.targetTouches[0]; if (e.target.scrubbingElement) { d.preventDefault(), b = e.target.scrubbingElement; var f = b.options.adapter.start(b), g = function (a) { return b.options.resolver.coordinate(a) }, h = g(e); c = function (a) { if (1 === a.targetTouches.length) { a.preventDefault(); var c = b.options.resolver.value(h, g(a.targetTouches[0])); b.options.adapter.change(b, f + c, c) } }, a.addEventListener("touchmove", c, !1) } } }, f = function () { a.addEventListener("touchcancel", d, !1), a.addEventListener("touchend", d, !1), f = function () { } }; return { init: function (a) { f(), a.node.addEventListener("touchstart", e, !1) }, remove: function () { } } }(a, b), m = function () { return { init: function (a) { a.node.addEventListener("mousewheel", function (b) { b.preventDefault(); var c = a.options.adapter.start(a); a.options.adapter.change(a, c - b.wheelDelta, b.wheelDelta) }, !1) }, remove: function () { } } }(a), n = { driver: [l, k], resolver: i(), adapter: f }, o = function (a, b) { return this instanceof o ? (this.node = a, this.options = {}, d(this.options, b, n, o.driver, "driver"), d(this.options, b, n, o.resolver, "resolver"), d(this.options, b, n, o.adapter, "adapter"), this.node.dataset.scrubOrientation = this.options.resolver.name, a.scrubbingElement = this, this.options.adapter.init(this), e(this.options.driver, "init", this), void 0) : new o(b) }; o.prototype = { remove: function () { delete node.scrubbingElement, e(this.options.driver, "remove", this) } }, o.driver = { Mouse: k, MouseWheel: m, Touch: l }, o.adapter = { BasicNode: f }, o.resolver = { DefaultHorizontal: i(), DefaultVertical: j(), HorizontalProvider: i, VerticalProvider: j }, a.Scrubbing = o }(window);


const Container = styled.div`
  display: flex;
  align-items: center;
`;

const InputArea = styled.div`
  margin-right: 15px;
  display: flex;
  align-items: center;

  &:last-child {
    margin: 0;
  }
`;


const Label = styled.div`
  margin-right: 5px;

  color: ${props => props.bwMode === "black" ? "#979797" : "#979797" };
`;


const Scrubber = styled.div`
  font-family: "UT Sans", sans-serif;
  font-size:0.9em;
  background-color: transparent;
  border: none;
  margin-right:5px;

  cursor: ns-resize;
  color: ${props => props.bwMode === "black" ? "white" : "black"};
`;

const ButtonArea = styled.div`
  margin-top:-7px;
`;

const ArrowBtn = styled.button`
  padding:0;
  margin:0;
  background:none;
  display: block;
  border: none;
  height: 12px;
`

class VariableController extends Component {
  constructor(props){
    super(props);

  }

  componentDidMount(){
    this.updateScrubber();
  }

  componentDidUpdate(){

    this.updateScrubber();
  }

  updateScrubber(){

    // if (this.props.mode === "up") {

    //   _.each(this.props.upVariables, (variableValue, variableKey) => {

    //     this[`${variableKey}_ref`] = React.createRef();

    //   });

    // } else {

    //   _.each(this.props.downVariables, (variableValue, variableKey) => {

    //     this[`${variableKey}_ref`] = React.createRef();

    //   });

    // }

    var nodeAdapter = {


      // Called everytime a new `scrubbingElement` was created.
      init: function (scrubbingElement) { },


      // Called before the scrubbing starts.
      //
      // Return the inital value for scrubbing
      start: function (scrubbingElement) {
        return parseInt(scrubbingElement.node.textContent, 10);
      },


      // Called if the `value` for the `scrubbingElement` has changed.
      // Where `value` is the value calculated from `start` and
      // the Resolver which is used.
      change: this.handleChange.bind(this),

      //  Called when the scrubbing ends.
      end: function (scrubbingElement) { }
    };

    let { upVariables, downVariables, mode } = this.props;
    let variables = mode === "up" ? upVariables : downVariables;

    _.each(variables, (variableValue, variableKey) => {
      let scrubber = new Scrubbing(document.querySelector(`#${variableKey}-${mode}`), { adapter: nodeAdapter, resolver: Scrubbing.resolver.DefaultVertical });
    });
  }

  handleChange(scrubbingElement, value) {
    let { upVariables, downVariables, mode } = this.props;

    let variables = mode === "up" ? upVariables : downVariables;

    let newVariables = {
      ...variables
    };

    let min = scrubbingElement.node.dataset.min;
    let max = scrubbingElement.node.dataset.max;

    newVariables[scrubbingElement.node.dataset.name].value = constrain(value, min, max);

    // console.log(upVariables, downVariables, mode, newVariables)

    if (mode === "up") {

      this.props.dispatch(changeUpVariables(newVariables));

    } else {

      this.props.dispatch(changeDownVariables(newVariables));

    }
  }

  handleArrowClick(variableKey, downUpMode, min, max) {
    let { upVariables, downVariables, mode } = this.props;

    let variables = mode === "up" ? upVariables : downVariables;

    let newVariables = {
      ...variables
    };

    let currentValue = newVariables[variableKey].value;
    if (downUpMode === "increase") {
      newVariables[variableKey].value = constrain(currentValue + 1, min, max);
    } else {
      newVariables[variableKey].value = constrain(currentValue - 1, min, max);

    }


    if (mode === "up") {

      this.props.dispatch(changeUpVariables(newVariables));

    } else {

      this.props.dispatch(changeDownVariables(newVariables));

    }
  }

  render() {
    let { upVariables, downVariables, bwMode, mode } = this.props;

    let variables = mode === "up" ? upVariables : downVariables;
    console.log(_.isEmpty(variables));
    return (
      <Container>

        {
          _.isEmpty(variables) ?
            null :
            _.map(variables, (variableValue, variableKey) => {
              return (
                <InputArea key={variableKey}>
                  <Label bwMode={bwMode}>
                    {variableKey}:
                  </Label>
                  <Scrubber ref={this[`${variableKey}_ref`]} data-name={variableKey} id={`${variableKey}-${mode}`} data-min={variableValue.range[0]} data-max={variableValue.range[1]} bwMode={bwMode}>
                    {variableValue.value }
                  </Scrubber>
                  <ButtonArea>
                    <ArrowBtn onClick={this.handleArrowClick.bind(this, variableKey, "increase", variableValue.range[0], variableValue.range[1])}>
                      <svg width="10" height="6" viewBox="0 0 10 6" fill="none">
                        <path d="M1.14108 5.73933L5 1.8257L8.85892 5.73933C9.16321 6.07965 9.46749 6.08674 9.77178 5.7606C10.0761 5.43446 10.0761 5.11542 9.77178 4.80346L5.45643 0.379364C5.34578 0.237565 5.19364 0.166667 5 0.166667C4.80636 0.166667 4.65422 0.237565 4.54357 0.379364L0.228217 4.80346C-0.0760717 5.11542 -0.0760717 5.43446 0.228217 5.7606C0.532507 6.08674 0.836791 6.07965 1.14108 5.73933Z" fill="#979797"/>
                      </svg>
                    </ArrowBtn>

                    <ArrowBtn  onClick={this.handleArrowClick.bind(this, variableKey, "decrease", variableValue.range[0], variableValue.range[1])}>
                      <svg width="10" height="6" viewBox="0 0 10 6" fill="none">
                        <path d="M8.85892 0.427172L5 4.3408L1.14108 0.427172C0.836791 0.0868555 0.532506 0.0797651 0.228217 0.405903C-0.0760723 0.73204 -0.0760723 1.05108 0.228217 1.36304L4.54357 5.78714C4.65422 5.92894 4.80636 5.99984 5 5.99984C5.19364 5.99984 5.34578 5.92894 5.45643 5.78714L9.77178 1.36304C10.0761 1.05108 10.0761 0.73204 9.77178 0.405903C9.46749 0.0797651 9.16321 0.0868555 8.85892 0.427172Z" fill="#979797"/>
                      </svg>
                    </ArrowBtn>
                  </ButtonArea>
                </InputArea>
              )
            })
        }

      </Container>
    )
  }
}

let mapStateToProps = state => {
  return {
    downVariables: state.downVariables,
    upVariables: state.upVariables,
    bwMode: state.bwMode
  }
}

export default connect(mapStateToProps)(VariableController);
